import router from "@/router";
import axios from "axios";
// 接口环境
import hostPath from "@config/host";
import common from "@/utils/common";
import store from '@/store'
// 设置baseURL
axios.defaults.baseURL = hostPath.apiUrl;

// 请求拦截器
axios.interceptors.request.use(
  function(config) {
    var nowObj = SETREQUESTDATA({});
    if (config.method === "get") {
      if (!config.params) {
        config.params = {};
      }
      config.params = Object.assign(config.params, nowObj);
      var getTK = store.state.sys.tk ? store.state.sys.tk : common.getToken();
      if (getTK) {
        if (!config.headers.token) {
          config.headers.token = getTK;
        }
      }
      var getUId = store.state.sys.uId ? store.state.sys.uId : common.getUserId();
      if (getUId) {
        if (!config.headers.userId) {
          config.headers.userId = getUId;
        }
      }
      // 后端需要 20220611
      config.headers.traceId =
        `${Math.round(Math.random() * 100000000)}` +
        `${new Date().getTime()}` +
        `${Math.round(Math.random() * 100000000)}`;
    } else {
      if (!config.data) {
        config.data = {};
      }
      config.data = Object.assign(config.data, nowObj);
      var getTK = store.state.sys.tk ? store.state.sys.tk : common.getToken();
      if (getTK) {
        if (!config.headers.token) {
          config.headers.token = getTK;
        }
      }
      var getUId = store.state.sys.uId ? store.state.sys.uId : common.getUserId();
      if (getUId) {
        if (!config.headers.userId) {
          config.headers.userId = getUId;
        }
      }
      // 后端需要 20220611
      config.headers.traceId =
        `${Math.round(Math.random() * 100000000)}` +
        `${new Date().getTime()}` +
        `${Math.round(Math.random() * 100000000)}`;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  function(response) {
    // 移除加载显示
    if (typeof response.data === "object") {
      if (response.data.status === 0 || response.data.status === 1) {
        return response.data;
      } else if (

        response.data.status === -100 ||
        response.data.status === -310 ||
        response.data.status === -108 ||
        response.data.status === -1
      ) {
        // 当需要过期或是另一台设备登录时
        common.showDailg(response, 0);
      } else if (!response.data.status && response.data.type) {
        if (response.data.type === "application/json") {
          // blob 转 json
          var reader = new FileReader();
          reader.readAsText(response.data);
          reader.onload = function(e) {
            if (e.target.readyState === 2) {
              var res = JSON.parse(e.target.result);
              if (
                res.status === -100 ||
                res.status === -310 ||
                res.status === -108 ||
                res.status === -201
              ) {
                // 错误信息
                common.showDailg(res, 1);
              }
            }
          };
        } else {
          return response;
        }
      } else {
        // 错误信息
        var showInfo = "";
        if (common.isEnLan()) {
          if (response.data.errorInfoEn) {
            showInfo = response.data.errorInfoEn;
          } else {
            showInfo = response.data.errorInfo;
          }
        } else {
          showInfo = response.data.errorInfo;
        }
        common.warningInfoTip(showInfo);
        return false;
      }
    } else {
      return response.data;
    }
  },
  function(responseError) {
    // 兼容处理超时时返回的404
    if (
      responseError &&
      responseError.response &&
      responseError.response.status === 404
    ) {
      // location.href = "/";
    }
  }
);

// 请求BODY的公共参数
function SETREQUESTDATA(data) {
  let obj = {};
  data && (obj = data);
  return obj;
}



//////////////////
// WEBPACK FOOTER
// ./config/axios.js
// module id = null
// module chunks = 